import Vue from 'vue'
import Router from 'vue-router'
import index from '../app/index'
import index2 from '../app/index2'
import myReports from '../app/myReports'
import orders from '../app/orders'
import home from '../app/home'
import service from '../app/service'
import developer from '../app/developer.vue'
import wechat from '../app/wechat.vue'
import hk from '../app/hk.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    { path: '/', name: 'home', component: home },
    { path: '/developer', name: 'developer', component: developer },
    { path: '/orders', name: 'orders', component: orders },
    { path: '/index', name: 'index', component: index },
    { path: '/hk', name: 'hk', component: hk },
    { path: '/index2', name: 'index2', component: index2 },
    { path: '/service', name: 'service', component: service },
    { path: '/wechat', name: 'wechat', component: wechat },
    { path: '/myReports', name: 'myReports', component: myReports }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js